import { useState, useEffect, useContext, useRef } from 'react';
import { Toast } from 'react-weui';
import { formatNumber } from 'lib/formatter.ts';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Big from 'big.js';
import Http from 'services/http2';
import Util from 'lib/util';
import BodydCustField from 'components/bodyCustField';
import CustFieldService from 'services/custField';
import ModalService from 'services/modal';
import { ActionContext } from 'actions/context';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import AppSelect from './select';

// 修改收货/入库数量

const Config = {
  receiveOrder: {
    title: '收货单',
    apiPath: '/receiveOrder/singleSave',
    xkNoProp: 'roXkNo',
    qtyProp: 'receiveValuationQty'
  },
  storageOrder: {
    title: '入库单',
    apiPath: '/storageOrder/singleSave',
    xkNoProp: 'stoXkNo',
    qtyProp: 'storageValuationQty'
  }
};

const styles = {
  paper: {
    margin: '10px',
    width: '90vw'
  }
};

function QtyRevise(props) {
  const {
    classes,
    companyCode,
    currItem,
    decimalPlace,
    type,
    fieldSetting,
    isPurchase
  } = props;
  const config = Config[type];
  const { state, dispatch } = useContext(ActionContext);
  const [errorMsg, setErrorMsg] = useState('');
  const [showLoading, setShowLoading] = useState(false);
  const [storeList, setStoreList] = useState(null); //仓库列表
  const [storeLocalList, setStoreLocalList] = useState(null); //库位列表
  const [bodyCustData, setBodyCustData] = useState({}); //单身自定义字段数据
  const [line, setLine] = useState({}); //单身可编辑字段

  //创建实例，用于储存非状态可变值
  let instant = useRef({
    getStoreList,
    getStoreLocalList,
    getLineData
  });
  let self = instant.current;

  //根据依赖多次执行
  useEffect(() => {
    // 初始化单身可编辑字段
    let lineData = self.getLineData(currItem);
    setLine({ ...lineData });

    self.getStoreList();
    if (!Util.isEmpty(currItem.storeCode)) {
      self.getStoreLocalList(currItem.storeCode, currItem.storeName);
    }

    //初始化bodyCustData
    let bodyCustList = fieldSetting.bodyCustList || [];
    let custData = {};
    //仅显示可编辑字段
    bodyCustList = bodyCustList
      .filter(
        field =>
          field.editFlag === 1 &&
          field.needVendorInputFlag === (isPurchase ? 0 : 1)
      )
      .forEach(field => {
        custData[field.fieldCode] = currItem[field.fieldCode];
      });
    setBodyCustData(custData);
  }, [companyCode, currItem, fieldSetting, isPurchase, self]);

  // 获取单身可编辑字段数据
  function getLineData(item) {
    let lineData = {};
    let arr = [
      'storageQty',
      'receiveQty',
      'returnQty',
      'receiveValuationQty',
      'storageValuationQty',
      'batchNo',
      'storeCode',
      'storeName',
      'locationCode',
      'locationName'
    ];
    arr.forEach(key => {
      lineData[key] = item[key];
    });
    return lineData;
  }

  //关闭弹窗
  function handleClose() {
    dispatch({ type: 'hideQtyRevise' });
  }

  //字段值改变
  function handleChange(event) {
    let { name, value } = event.target;
    setLine(Object.assign({}, line, { [name]: value }));
  }

  //仓库列表
  async function getStoreList() {
    let postbody = {
      companyCode,
      apiPath: '/archives/store/getList'
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data;
        if (Array.isArray(data) && data.length !== 0) {
          let arr = [];
          data.forEach(val => {
            if (val.storeCode) {
              arr.push({
                value: val.storeCode,
                label: val.storeCode + ' - ' + val.storeName,
                name: val.storeName
              });
            }
          });
          setStoreList(arr);

          //当仓库地址为1个时， 自动填充仓库地址
          // if (arr.length === 1) {
          //   let lineData = getLineData(currItem);
          //   setLine(
          //     Object.assign(lineData, {
          //       storeCode: arr[0].value,
          //       storeName: arr[0].name
          //     })
          //   );
          //   self.getStoreLocalList(line.storeCode, line.storeName);
          // }
        }
      }
    });
  }

  //库位列表
  function getStoreLocalList(storeCode, storeName) {
    if (Util.isEmpty(storeCode)) {
      return;
    }
    let postbody = {
      companyCode,
      storeCode: storeCode,
      apiPath: '/archives/storeLocation/getList'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data;
        if (Array.isArray(data) && data.length !== 0) {
          let arr = [];
          data.forEach(val => {
            if (val.locationCode) {
              arr.push({
                value: val.locationCode,
                label: val.locationCode
                  ? val.locationCode + ' - ' + val.locationName
                  : val.locationName,
                name: val.locationName
              });
            }
          });
          setStoreLocalList(arr);
          //当库位为1个时， 自动填充库位信息
          // if (arr.length === 1) {
          //   let lineData = getLineData(currItem);
          //   setLine(
          //     Object.assign(lineData, {
          //       storeCode,
          //       storeName,
          //       locationCode: arr[0].value,
          //       locationName: arr[0].name
          //     })
          //   );
          // }
        }
      }
    });
  }

  //仓库改变
  function handleStoreChange(event) {
    let code = event.value;
    let name;
    storeList.forEach(item => {
      if (item.value === code) {
        name = item.name;
      }
    });

    setLine(
      Object.assign({}, line, {
        storeCode: code,
        storeName: name,
        locationCode: '',
        locationName: ''
      })
    );

    setStoreLocalList([]);
    setErrorMsg('');

    getStoreLocalList(code, name);
  }

  //库位改变
  function handleLocationChange(event) {
    let code = event.value;
    let name;
    storeLocalList.forEach(item => {
      if (item.value === code) {
        name = item.name;
      }
    });
    setLine(
      Object.assign({}, line, {
        locationCode: code,
        locationName: name
      })
    );

    setErrorMsg('');
  }

  function handleOk() {
    if (!validate()) {
      return;
    }
    // if (
    //   !CustFieldService.validate(
    //     undefined,
    //     [bodyCustData],
    //     fieldSetting,
    //     true,
    //     dispatch
    //   )
    // ) {
    //   return;
    // }

    let params = {
      stoXkNo: currItem.stoXkNo,
      storageQty: currItem.storageQty,
      returnQty: currItem.returnQty
    };
    if (type === 'receiveOrder') {
      params = {
        roXkNo: currItem.roXkNo
      };
    }

    let postbody = {
      companyCode: currItem.companyCode,
      lineNo: currItem.lineNo,
      ...params,
      ...line,
      ...bodyCustData,
      apiPath: config.apiPath
    };
    setShowLoading(true);
    Http.post('/api/cloudCenter?btnId=001', postbody).then(response => {
      setShowLoading(false);
      if (response.success) {
        setErrorMsg('');
        handleClose();
        props.onChange('success');
        ModalService.showTip('保存成功', dispatch);
      } else {
        setErrorMsg(response.errorMsg);
      }
    });
  }

  function validate() {
    let result = true;
    let sumNum = Big(line.storageQty || 0).plus(line.returnQty || 0);
    //let receiveQty = parseFloat(line.receiveQty);
    sumNum = parseFloat(sumNum);
    // if (receiveQty !== sumNum && type === 'storageOrder') {
    //   setErrorMsg('数据异常,收货数量不等于入库数量+退货数量');
    //   return false;
    // }
    // if (receiveQty > currItem.srcReceiveQty) {
    //   setErrorMsg('数据异常,收货数量大于待转出货量');
    //   return false;
    // }
    return result;
  }

  return (
    <div>
      <Dialog
        classes={{ paper: classes.paper }}
        open={state.showQtyRevise}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          <div className="dialog order-detail-item">
            {/* <div className="line">
              <span>项次：</span>
              <div>{currItem.poLineNoShow}</div>
            </div> */}
            <div className="line">
              <span>物料编码：</span>
              <div>{currItem.productCode}</div>
            </div>
            {/* <div className="line">
              <span>物料名称：</span>
              <div>{currItem.productName}</div>
            </div>
            <div className="line">
              <span>物料规格：</span>
              <div>{currItem.productScale}</div>
            </div> */}
            {type === 'receiveOrder' && (
              <div className="line">
                <span>收货数量：</span>
                <div>
                  <input
                    type="number"
                    name="receiveQty"
                    value={line.receiveQty || ''}
                    onChange={handleChange}
                  />
                </div>
              </div>
            )}
            {type === 'storageOrder' && (
              <div className="line">
                <span>入库数量：</span>
                <div>
                  <input
                    type="number"
                    name="storageQty"
                    value={line.storageQty || ''}
                    onChange={handleChange}
                  />
                </div>
              </div>
            )}
            <div className="line">
              <span>计价数量：</span>
              {!currItem.isEditValuationQty && (
                <div>
                  {formatNumber(
                    currItem[config.qtyProp],
                    decimalPlace.Quantity_Decimal_Place
                  )}
                </div>
              )}

              {type === 'storageOrder' && currItem.isEditValuationQty && (
                <div>
                  <input
                    type="number"
                    name="storageValuationQty"
                    value={line.storageValuationQty || ''}
                    onChange={handleChange}
                  />
                </div>
              )}
              {type === 'receiveOrder' && currItem.isEditValuationQty && (
                <div>
                  <input
                    type="number"
                    name="receiveValuationQty"
                    value={line.receiveValuationQty || ''}
                    onChange={handleChange}
                  />
                </div>
              )}
            </div>
            {type === 'storageOrder' && (
              <div className="line">
                <span>收货数量：</span>
                <div>
                  <input
                    type="number"
                    name="receiveQty"
                    value={line.receiveQty || ''}
                    onChange={handleChange}
                  />
                </div>
              </div>
            )}
            {type === 'storageOrder' && (
              <div className="line">
                <span>退货数量：</span>
                <div>
                  <input
                    type="number"
                    name="returnQty"
                    value={line.returnQty || ''}
                    onChange={handleChange}
                  />
                </div>
              </div>
            )}
            <div className="line">
              <span>{type === 'storageOrder' ? '入库' : '收货'}仓库：</span>
              <div>
                {storeList && (
                  <AppSelect
                    value={line.storeCode}
                    options={storeList}
                    change={handleStoreChange}
                  ></AppSelect>
                )}
              </div>
            </div>
            <div className="line">
              <span>{type === 'storageOrder' ? '入库' : '收货'}库位：</span>
              <div>
                {storeLocalList && (
                  <AppSelect
                    value={line.locationCode}
                    options={storeLocalList}
                    change={handleLocationChange}
                  ></AppSelect>
                )}
              </div>
            </div>
            <div className="line">
              <span>收货批号：</span>
              <div>
                <input
                  type="text"
                  name="batchNo"
                  value={line.batchNo || ''}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          {/* 单身自定义字段 */}
          <BodydCustField
            isEdit={true}
            fieldSetting={fieldSetting}
            line={currItem}
            bodyCustData={bodyCustData}
            setBodyCustData={setBodyCustData}
            isPurchase={isPurchase}
          ></BodydCustField>
          {errorMsg && <p className="error-tip">{errorMsg}</p>}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            取消
          </Button>
          <Button onClick={handleOk} color="primary">
            确定
          </Button>
        </DialogActions>
      </Dialog>
      <Toast icon="loading" show={showLoading}>
        Loading...
      </Toast>
    </div>
  );
}

QtyRevise.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(QtyRevise);
